<template>
  <div>
    <v-layout class="title" align-baseline justify-space-between>
      <v-flex xs1>
        {{ $t('labelDetails') }}:
      </v-flex>
      <v-flex md2>
        <v-autocomplete
          hide-details
          :items="templates"
          return-object
          :label="$t('template')"
          item-text="name"
          @change="onSelectTemplate"></v-autocomplete>
      </v-flex>
      <v-flex xs1>
        <v-menu
          :close-on-content-click="false"
          v-model="shipDateMenu"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <template v-slot:activator="data">
            <v-text-field
              hide-details
              :value="shipDate"
              :label="$t('shipDate')"
              readonly
              v-on="data.on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="shipDate" @input="shipDateMenu = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs3>
        <v-select
          hide-details
          :items="filterShippingServiceByFromState(shippingServices, fromState)"
          item-text="text"
          item-value="value"
          :menu-props="{returnValue:'value'}"
          v-model="shippingService"
          :rules="[fieldIsRequired('service'), checkShipForm()]"
          :label="$t('shippingService')"
        >
          <template v-slot:item="data">
            <template v-if="isObject(data.item)">
              <v-list-tile-content v-text="data.item"></v-list-tile-content>
            </template>
            <template v-else>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{data.item.text}}
                </v-list-tile-title>
              </v-list-tile-content>
            </template>
          </template>
        </v-select>
      </v-flex>
      <v-flex xs2>
        <v-select
          class="table-item"
          hide-details
          :label="$t('signature')"
          :items="signatureOptions"
          item-text="text"
          :menu-props="{returnValue:'value'}"
          v-model="signature"/>
      </v-flex>
      <v-flex xs2>
        <v-select
          class="table-item"
          hide-details
          :label="$t('labelStockType')"
          :items="labelStockTypes"
          item-text="text"
          :menu-props="{returnValue:'value'}"
          :disabled="!isSupportLabelStockType"
          v-model="labelStockType"/>
      </v-flex>
    </v-layout>
    <v-layout justify-space-between>
      <v-flex v-bind="{ md6: isSupportSaturdayDelivery, md7: !isSupportSaturdayDelivery }">
        <v-text-field
          :label="$t('note')"
          :hint="$t('noteWillNotBePrintedOnLabel')"
          v-model.trim="note"
          :rules="[fieldCharLimit('Note', 100)]"
          counter="100"></v-text-field>
      </v-flex>
      <v-flex v-bind="{ md3: isSupportSaturdayDelivery, md4: !isSupportSaturdayDelivery }">
        <v-text-field
          :label="$t('memo')"
          :hint="$t('memoWillBePrintedOnLabel')"
          :rules="[fieldCharLimit('Memo', 40)]"
          v-model.trim="memo"
          counter="40"></v-text-field>
      </v-flex>
      <v-flex md2 v-if="isSupportSaturdayDelivery">
        <v-checkbox
          v-model="isSaturdayDelivery"
          :label="$t('supportSaturdayDelivery')"
        ></v-checkbox>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="packages"
      hide-actions
      class="elevation-2 mt-2"
      item-key="index"
      caption
    >
      <template v-slot:headerCell="props">
        <span v-if="props.header.value === 'action'">
          <v-tooltip top>
            <template v-slot:activator="tooltip">
              <v-btn v-on="tooltip.on" color="primary" flat small icon @click="addPackage" :disabled="!serviceSetting.enableMWT"><v-icon>add</v-icon></v-btn>
            </template>
            {{ $t('supportUpToMaxPkgQtyPackages', { maxPkgQty: serviceSetting.maxPkgQty }) }}
          </v-tooltip>
        </span>
        <span v-else>{{ props.header.text }}</span>
      </template>
      <template v-slot:items="props">
        <td class="text-xs-center">
          <v-btn v-if="props.index > 0" color="primary" flat small icon @click="deletePackage(props.item)"><v-icon>delete</v-icon> </v-btn>
        </td>
        <td text-xs-center>
          <v-text-field
            class="table-item"
            hide-details
            v-model="props.item.description"
            :rules="[fieldIsRequired('description')]"
          ></v-text-field>
        </td>
        <td class="text-xs-left">
          <v-layout align-baseline justify-center>
            <v-flex xs6 pr-2>
              <v-text-field
                class="table-item"
                hide-details
                v-model.number="props.item.qty"
                :disabled="!serviceSetting.enableMWT"
                :rules="[
                  fieldIsRequired('qty'), 
                  fieldIsOverZero('qty'),
                  fieldIsInteger('qty')
                ]"
              ></v-text-field>
            </v-flex>
              /
            <v-flex xs6 pl-2>
              <v-text-field
                class="table-item"
                hide-details
                v-model.number="props.item.pieces"
                :rules="[
                  fieldIsRequired('pieces'), 
                  fieldIsOverZero('pieces'),
                  fieldIsInteger('pieces')
                ]"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </td>
        <td class="text-xs-left">
          <v-text-field
            class="table-item"
            hide-details
            v-model.number="props.item.weightLb"
            :rules="[
              fieldIsRequired('weight'), 
              fieldIsNoLessThanZero('weight'),
              isMeasurementMetric ? (() => true) : fieldIsPkgWeight(isOz)
            ]"
            :suffix="isMeasurementMetric ? 'kg' : (isOz ? 'Oz' : 'Lbs')"></v-text-field>
        </td>
        <td class="text-xs-left">
          <v-layout align-center>
            <v-flex xs4 class="mr-3">
              <v-text-field
                class="table-item"
                hide-details
                v-model.number="props.item.length"
                :suffix="sizeSuffix"
                :rules="[
                  fieldIsRequired('length'), 
                  fieldIsOverZero('length')
                ]"></v-text-field>
            </v-flex>
            <v-flex xs4 class="mr-3">
              <v-text-field
                class="table-item"
                hide-details
                v-model.number="props.item.width"
                :suffix="sizeSuffix"
                :rules="[
                  fieldIsRequired('width'), 
                  fieldIsOverZero('width')
                ]"></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                class="table-item"
                hide-details
                v-model.number="props.item.height"
                :suffix="sizeSuffix"
                :rules="[
                  fieldIsRequired('height'), 
                  fieldIsOverZero('height')
                ]"></v-text-field>
            </v-flex>
            <v-flex xs1>
              <PackagingSelector
                :packagings="packagings"
                @select="item => onSelectPackaging(item, props.item)"
              />
            </v-flex>
          </v-layout>
        </td>
        <td class="text-xs-left">
          <LabelFreightClassSelector
            v-model="props.item.freightClass"
            :length="props.item.length"
            :width="props.item.width"
            :height="props.item.height"
            :weight="props.item.weightLb"
            :isMeasurementMetric="isMeasurementMetric"
          ></LabelFreightClassSelector>
        </td>
        <td class="text-xs-left">
          <v-text-field
            class="table-item"
            hide-details
            :disabled="!serviceSetting.enableInsured"
            v-model.number="props.item.insuredValue"
            @change="(e) => defaultZero(e, props.item)"
            :rules="[fieldIsRequired('value'), fieldIsNoLessThanZero('value')]"></v-text-field>
        </td>
        <td class="text-xs-left">
           <v-edit-dialog
              :return-value="props.item.memo"
              lazy
            > <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn icon flat v-on="on"><v-icon>note</v-icon></v-btn>
              </template>
              {{ props.item.memo || '** no memo **' }}
            </v-tooltip>
              <template v-slot:input>
                <div class="mt-3">{{ $t('memo') }}</div>
                <v-text-field
                  :label="$t('edit')"
                  v-model.number="props.item.memo"
                  single-line
                  autofocus
                ></v-text-field>
              </template>
            </v-edit-dialog>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import LabelPackageWidget from './LabelPackageWidget.vue'
import LabelFreightClassSelector from './LabelFreightClassSelector'
import PackagingSelector from './PackagingSelector'

export default {
  name: 'LabelFreightPkgWidget',
  extends: LabelPackageWidget,
  components: {
    LabelFreightClassSelector,
    PackagingSelector
  },
  computed: {
    shippingServices () {
      return this.$store.getters.freightShippingServices
    },
    isFreight () {
      return true
    },
    packageStat () {
      return this.packages.reduce((stat, pkg) => ({
        totalQty: stat.totalQty + pkg.qty,
        totalPieces: stat.totalPieces + (pkg.pieces || 0) * (pkg.qty || 1),
        totalWeight: Math.round((stat.totalWeight + pkg.weightLb * pkg.qty) * 100) / 100
      }), {
        totalQty: 0,
        totalWeight: 0,
        totalPieces: 0
      })
    },
    headers () {
      const headers = [
        { text: 'Action', value: 'action', align: 'center', sortable: false },
        { text: this.$t('freightDescription'), value: 'description', align: 'left', sortable: false, width: '15%' },
        { 
          text: `${this.$t('freightUnits')} (${this.packageStat.totalQty}) / ${this.$t('piecesPerPallet')} (${this.packageStat.totalPieces})`,
          value: '',
          align: 'left',
          sortable: false,
          width: '13%'
        },
        this.isMeasurementMetric ? 
          { text: `${this.$t('weight')}(${this.packageStat.totalWeight}kg)`, value: 'weight', align: 'left', sortable: false } : 
          { text: `${this.$t('weight')}(${this.packageStat.totalWeight}${this.isOz ? 'Oz' : 'Lbs'})`, value: 'weight', align: 'left', sortable: false },
        { text: `${this.$t('length')} / ${this.$t('width')} / ${this.$t('height')}`, value: 'packaging', align: 'left', sortable: false, width: '18%' },
        { text: this.$t('freightClass'), value: 'freightClass', align: 'left', sortable: false, width: '13%' },
        { text: this.$t('declaredValue'), value: 'createTime', align: 'left', sortable: false },
        { text: this.$t('memo'), value: 'memo', align: 'left', sortable: false }
      ]
      return headers
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LabelFreightPkgWidget.vue